import { useReportBundleStore } from '@/frontend/store/ReportBundleStore';
import { AssistantMessage, AssistantStreamEvent } from '@/types/reportAssistantTypes';

/**
 * How the studio asks for one reply: the whole history out, the reply's
 * events back as they stream. The hook takes it as a parameter so tests can
 * script a conversation without a server.
 */
export type AssistantTransport = (bundleId: string, messages: AssistantMessage[], onEvent: (event: AssistantStreamEvent) => void, signal: AbortSignal) => Promise<void>;

export const storeAssistantTransport: AssistantTransport = (bundleId, messages, onEvent, signal) => useReportBundleStore.getState().streamAssistantReply(bundleId, messages, onEvent, signal);
